var exports = {
  "jw": "MessageThreadChip.module__chip___dUFNeU",
  "nM": "MessageThreadChip.module__row___dUFNeU",
  "UU": "MessageThreadChip.module__name___dUFNeU",
  "U9": "MessageThreadChip.module__count___dUFNeU",
  "VH": "MessageThreadChip.module__preview___dUFNeU",
};

module.exports = exports;
